import { BaseEdge, getBezierPath, type EdgeProps } from "@xyflow/react";

export function SubmitEdge(props: EdgeProps) {
  const { sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, id } = props;
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return <BaseEdge id={id} path={edgePath} style={{ stroke: "#94a3b8", strokeWidth: 2 }} />;
}
